import { cn } from '@/lib/cn';
import type { ScreenName } from '@/types/domain';

// The 7-screen linear flow. Customization shares the menu step's dot.
const STEPS: ScreenName[] = [
  'welcome',
  'order-type',
  'menu',
  'cart',
  'confirmation',
  'instructions',
];

function stepIndexFor(screen: ScreenName): number {
  if (screen === 'customization') return STEPS.indexOf('menu');
  return STEPS.indexOf(screen);
}

export function ProgressDots({ current }: { current: ScreenName }) {
  const activeIndex = stepIndexFor(current);
  return (
    <div className="flex items-center justify-center gap-2" aria-hidden>
      {STEPS.map((step, i) => (
        <span
          key={step}
          className={cn(
            'h-2 rounded-full transition-all duration-200',
            i === activeIndex ? 'w-6 bg-brand-teal' : 'w-2',
            i < activeIndex ? 'bg-brand-teal/60' : i > activeIndex ? 'bg-hairline' : '',
          )}
        />
      ))}
    </div>
  );
}
